import { ColumnType } from "antd/lib/table";
import Actions from "./Actions";
import Badge from "ui/components/badge";

const columns: ColumnType<any>[] = [
  {
    title: "CÓDIGO",
    dataIndex: "codigo",
    align: "center",
    render: (value: string) => (
      <span style={{ fontWeight: "bold" }}>{value ?? "-"}</span>
    ),
  },
  {
    title: "DESCRIÇÃO",
    dataIndex: "descricao",
    align: "center",
    render: (value: string) => <span>{value ?? "-"}</span>,
  },
  {
    title: "COR",
    dataIndex: "cor",
    align: "center",
    render: (value: string) => (
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: 4,
          backgroundColor: value,
          margin: "0 auto",
        }}
      ></div>
    ),
  },
  {
    title: "OPERAÇÕES",
    dataIndex: "quantidadeOperacoes",
    align: "center",
    render: (value: string) => (
      <span>{value ? `${value} operações` : "-"}</span>
    ),
  },
  {
    title: "STATUS",
    dataIndex: "ativo",
    align: "center",
    render: (value: boolean) => (
      <Badge
        type={value ? "success" : "danger"}
        value={value ? "Ativo" : "Inativo"}
      />
    ),
  },
  {
    title: "AÇÕES",
    dataIndex: "operacaoClasseId",
    align: "center",
    render: (value: string, record: any) => (
      <Actions
        id={value}
        classe={record.descricao}
        operations={record.quantidadeOperacoes}
      />
    ),
  },
];

export default columns;
